import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { reduceEachTrailingCommentRange, textChangeRangeIsUnchanged } from 'typescript';
import { MemberService } from '../../Services/member.service';

@Component({
  selector: 'app-membercard-checker',
  template: require('./membercard-checker.component.html'),
  styles: [require('./membercard-checker.component.css')]
})
export class MembercardCheckerComponent implements OnInit {

  tocheck:string = ""

  isMember:boolean = true;
  memberName:string = "";


  constructor(private route: ActivatedRoute, private memberService:MemberService) {
    route.params.subscribe(p => {
      if (p['tocheck']) {
        this.tocheck= p['tocheck'];
      }
      else {
        this.tocheck = "";
      }
    });

    this.memberService.checkMemberCard(this.tocheck).subscribe ( res => {
      if (res.status == 200){
        this.isMember = true;
        this.memberName = res.value
      }
      else if (res.status == 204) {
        this.isMember=false;
        this.memberName = "";
      }
    })

  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/membercard-checker/membercard-checker.component.ts